$(document).ready(function() {
    setTimeout(function() {
        $('.loop-btn-add-to-cart').click(function() {
            
        });
    }, 2500)
    if ($('.subscription-popup').length) {
        if (sessionStorage.getItem('subsPopUp') === null) {
            $('.subscription-popup').addClass('show');
            sessionStorage.setItem('subsPopUp', 'true');
        }
        $('.close-button').click(function() {
            $('.subscription-popup').removeClass('show');
        });
    }
  }
);